import { Component, Input, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { Contact } from 'src/model/contact.model';
import { Customer } from 'src/model/customer.model';
import { CustomerAccount } from 'src/model/customerAccount.model';

@Component({
    selector: 'app-account-authorization-letter',
    templateUrl: './account-authorization-letter.component.html',
    styleUrl: './account-authorization-letter.component.scss',
    standalone: false
})
export class AccountAuthorizationLetterComponent {
  private router = inject(Router);
  protected sharedService = inject(SharedService);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private activatedRoute = inject(ActivatedRoute);


  selectedCompany: Company;
  @Input() selectedCompanyID: number;
  selectedCustomer: Customer;
  @Input() selectedCustomerID: number;

  @Input() selectedContact: Contact;
  @Input() selectedAccount: CustomerAccount;

  routeSubscription: any;

  constructor() {
    this.routeSubscription = this.activatedRoute.paramMap.subscribe(async params => {
      this.selectedCustomerID = + params.get('customerId');
      this.selectedCompanyID = + params.get('companyId');

      this.selectedAccount = this.router.getCurrentNavigation().extras.state.account;
      this.selectedContact = this.router.getCurrentNavigation().extras.state.contact;

      this.selectedCompany = await this.getCompanyInfo();
      this.selectedCustomer = await this.getCustomerInfo();

    })
  }


  getCompanyInfo() {
    return new Promise<Company>(resolve => {
      const xhttp = this.restapi.getRequest(this.constructApi.getCompanyDetails(this.selectedCompanyID))
      xhttp.onreadystatechange = () => {
        if (xhttp.readyState == 4 && xhttp.status == 200) {
          const json = JSON.parse((xhttp.responseText));
          resolve(new Company(json.id, json.name, json.address, json.companyCode, json.contactNo, undefined, json.regNo));
        }
      }
    });
  }

  getCustomerInfo() {

    return new Promise<Customer>(resolve => {
      const xhttp = this.restapi.getRequest(this.constructApi.getCustomerDetails(this.selectedCustomerID))
      xhttp.onreadystatechange = () => {
        if (xhttp.readyState == 4 && xhttp.status == 200) {
          const json = JSON.parse((xhttp.responseText));
          const customer = new Customer(json.id, json.name, json.occupation,
            json.salary, json.salaryDay, json.icNumber, json.contactNo, json.remark, json.ctosNumber, json.ctosStatus,
            json.status, json.dateCreated, json.handler, json.companyId, json.customerCode, json.companyName, json.reserve, json.badDebt, json.address, undefined, undefined, undefined, json.epfDate);

          resolve(customer)
        }
      }
    });

  }

}
